// Must be the app's first import, and must not import any store: persistState only registers stores
// .. created after it runs, plus a replay of the last 50 created in the last 5s, so a store created
// .. before it may never be loaded from or saved to storage.
import { configureStores } from './state.config';

configureStores();
